import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const FinalCTA = () => {
  return (
    <section className="relative py-28 px-6" data-testid="section-final-cta">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative rounded-[32px] overflow-hidden glass edge-glow p-10 sm:p-16"
        >
          <div aria-hidden className="absolute -top-36 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-aura-cyan/15 blur-[140px] opacity-70" />
          <div aria-hidden className="absolute -bottom-32 -right-32 w-[500px] h-[500px] rounded-full bg-aura-violet/20 blur-[140px] opacity-50" />
          <div className="relative text-center">
            <div className="section-label">Final thought</div>
            <h2 className="mt-5 headline text-[clamp(40px,7vw,96px)] font-extralight tracking-[-0.035em] leading-[0.98]">
              Your tutor should<br />
              <em>not</em> forget you.
            </h2>
            <div className="mt-8 flex items-center justify-center flex-wrap gap-4">
              <Link to="/onboarding" className="btn-primary" data-testid="final-cta-button">
                Reserve your memory
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
              </Link>
              <Link to="/dashboard/session" className="btn-ghost" data-testid="final-cta-secondary">See a live session</Link>
            </div>
            <div className="mt-6 font-mono text-[11px] tracking-[0.22em] uppercase text-whisper-muted">
              Immersive language intelligence · v3.1
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
